import React from 'react';
import {inject, observer} from 'mobx-react';
import {IMG_PATH} from '../../constant';
import Slide from '../Slide';
import './index.scss';
import {commonJump} from 'utils/utils';

@inject(({store}) => ({
    mstj: store.renderData.mstj
}))
@observer
class Food extends React.Component {
    render() {
        const {mstj: {data = []}} = this.props;

        if (!data.length) {
            return null;
        }
        return <div className="module m-nav m-food" id="mstj">
            <img className="img-bg" src={`${IMG_PATH}/ddms.png`} />
            <div className="mf-content">
                <Slide>
                    {
                        data.map((v, k) => {
                            const {img = {}, jumpInfo = {}} = v;
                            return <div className="img-wrap" onClick={() => {
                                if(!jumpInfo.touchUrl) return;
                                commonJump(jumpInfo);
                            }}><img className="img" key={k} src={img.touch} /></div>;
                        })
                    }
                </Slide>
            </div>
        </div>;
    }
}

export default Food;